import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'
import { convertUtcDate } from '../components/Common/cleanDates';

import {
    REQUEST_INVENTORY_RELOCATIONS,
    FETCH_INVENTORY_RELOCATIONS_SUCCESS,
    FETCH_INVENTORY_RELOCATIONS_FAILURE,
    SELECT_INVENTORY_RELOCATION,
    RESET_CURRENT_INVENTORY_RELOCATION,
    REQUEST_INVENTORY_RELOCATION_DETAIL,
    FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS,
    FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE,
    REQUEST_CREATING_INVENTORY_RELOCATION,
    CREATE_INVENTORY_RELOCATION_SUCCESS,
    CREATE_INVENTORY_RELOCATION_FAILURE,
    REQUEST_EDITING_INVENTORY_RELOCATION,
    EDIT_INVENTORY_RELOCATION_SUCCESS,
    EDIT_INVENTORY_RELOCATION_FAILURE
} from './type'

import {
    INVENTORY_RELOCATIONS_URL
} from './url';


// InventoryRelocations Actions
import { DEFAULT_ERROR } from '../components/Common/constants';

export function fetchInventoryRelocations() {
    return dispatch => {
        dispatch({ type: REQUEST_INVENTORY_RELOCATIONS });
        return axios.get(INVENTORY_RELOCATIONS_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchInventoryRelocationsSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchInventoryRelocationsFailure(err));
            });
    }
}

export function fetchInventoryRelocationsSuccess(inventoryRelocations) {
    return {
        type: FETCH_INVENTORY_RELOCATIONS_SUCCESS,
        payload: inventoryRelocations
    };
}

export function fetchInventoryRelocationsFailure(error) {
    return {
        type: FETCH_INVENTORY_RELOCATIONS_FAILURE,
        payload: error
    };
}

export function selectInventoryRelocation(inventoryRelocation) {
    return {
        type: SELECT_INVENTORY_RELOCATION,
        payload: inventoryRelocation
    };
}

export function resetCurrentInventoryRelocation() {
    return {
        type: RESET_CURRENT_INVENTORY_RELOCATION
    }
}


export function fetchInventoryRelocationDetail(inventoryRelocation_id) {
    return dispatch => {
        dispatch({ type: REQUEST_INVENTORY_RELOCATION_DETAIL });
        return axios.get(INVENTORY_RELOCATIONS_URL + inventoryRelocation_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchInventoryRelocationDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(fetchInventoryRelocationDetailFailure(err));
            });
    }
}

export function fetchInventoryRelocationDetailSuccess(inventoryRelocationDetail) {
  inventoryRelocationDetail = inventoryRelocationDetail.data;
  if(inventoryRelocationDetail.PostingDate) inventoryRelocationDetail.PostingDate = convertUtcDate(inventoryRelocationDetail.PostingDate);
    return {
        type: FETCH_INVENTORY_RELOCATION_DETAIL_SUCCESS,
        payload: inventoryRelocationDetail
    };
}

export function fetchInventoryRelocationDetailFailure(error) {
    return {
        type: FETCH_INVENTORY_RELOCATION_DETAIL_FAILURE,
        payload: error
    };
}

export function createInventoryRelocation(
  Warehouse_id,
  PostingDate,
  Note,
  Warehouse_Relocation_Line
) {
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    else PostingDate = convertUtcDate();
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_INVENTORY_RELOCATION });
        axios.post(INVENTORY_RELOCATIONS_URL,
            {
              Warehouse_id,
              PostingDate,
              Note,
              Warehouse_Relocation_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createInventoryRelocationSuccess());
              browserHistory.push('/inventories/relocation');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(createInventoryRelocationFailure(err));
            });
    }
}

export function createInventoryRelocationSuccess() {
    return {
        type: CREATE_INVENTORY_RELOCATION_SUCCESS
    }
}

export function createInventoryRelocationFailure(error) {
    return {
        type: CREATE_INVENTORY_RELOCATION_FAILURE,
        payload: error
    }
}

export function editInventoryRelocation(
  WarehouseRelocation_id,
  Warehouse_id,
  PostingDate,
  Note,
  Warehouse_Relocation_Line
) {
    if (PostingDate) PostingDate = convertUtcDate(PostingDate);
    else PostingDate = convertUtcDate();
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_INVENTORY_RELOCATION });
        axios.put(INVENTORY_RELOCATIONS_URL + WarehouseRelocation_id,
            {
              Warehouse_id,
              PostingDate,
              Note,
              Warehouse_Relocation_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editInventoryRelocationSuccess());
              browserHistory.push('/inventories/relocation');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              dispatch(editInventoryRelocationFailure(err));
            });
    }
}

export function editInventoryRelocationSuccess() {
    return {
        type: EDIT_INVENTORY_RELOCATION_SUCCESS
    }
}

export function editInventoryRelocationFailure(error) {
    return {
        type: EDIT_INVENTORY_RELOCATION_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/inventoryRelocations_actions.js